// extracted by mini-css-extract-plugin
export default {"customPopOverContainer":"CustomPopOver_customPopOverContainer__dz8oD","customProfileInfoContainer":"CustomPopOver_customProfileInfoContainer__jCDC8"};